/**
 * @owner @Appboy/core-objects
 */
export const appsCatalogItems = "/apps/catalog_items";
